// Quotas personnalisés du compte saisis dans l'admin (user._premium.quotas, via /users/me) :
// prioritaires sur Lock.js et sur les exceptions codées en dur. null = pas de quota personnalisé.
export function quotaOverride(kind, user) {
  let u = user
  if (!u || !u._premium) {
    try {
      u = localStorage.user && localStorage.user !== 'undefined' ? JSON.parse(localStorage.user) : null
    } catch (e) {
      u = null
    }
  }
  const quotas = u && u._premium && u._premium.quotas
  const n = quotas ? quotas[kind] : undefined
  return Number.isInteger(n) && n >= 0 ? n : null
}
